import { useState } from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { usePayrollResults } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import paymentItems from 'modules/payroll_bundle/store/collections/paymentItems'
import payments from 'modules/payroll_bundle/store/collections/payments'
import resultsCollection from 'modules/payroll_bundle/store/collections/results'

export const useFetchResultData = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { resultDispatch } = usePayrollResults()
  const { currentPolicyPeriods, periodIndex } = usePolicyPeriods()

  const fetchData = async () => {
    setIsLoading(true)

    const policyPeriodId = currentPolicyPeriods[periodIndex]?.id

    const data = {
      data: {
        policy_period_id: policyPeriodId,
      },
    }
    await Promise.all([
      resultsCollection.fetch(data),
      payments.fetch(data),
      paymentItems.fetch(data),
    ])

    const activeResult = resultsCollection.at(0)

    const selectedFields = activeResult?.attributes.selected_fields?.split(',') || []
    resultDispatch({
      type: UPDATE_DATA,
      payload: {
        disableUploadButton: resultsCollection.length > 0,
        selectedFields,
      },
    })
    setIsLoading(false)
  }

  useUnsafeEffect(() => {
    fetchData()
  }, [periodIndex]) // eslint-disable-line react-hooks/exhaustive-deps

  return { isLoading, fetchData }
}
